
import { Stack, Typography, Button, Box, Tooltip } from '@mui/material'
import React, { useEffect } from 'react'
import ScrollBox from '../../../components/ScrollBox';
import BackButton from '../../../components/BackButton';
import LabelTxt from '../../../components/LabelTxt';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useQuery, useQueryClient } from 'react-query';
import QueryKey from '../../../utils/QueryKey';
import { formatDateWithJs, isEmpty, isNotEmpty, makeTxtOverFLow } from '../../../utils/format';
import { useAuthContext } from '../../../context/AuthContext';
import { customAlert, notify } from '../../../components/notify';
import route from '../../../utils/Routes';
import PathBtns from '../../../components/PathBtns';
import industryIcon from '../../../assets/svg/industry-factory-color-icon 1.svg';
import downlodicon from '../../../assets/svg/downloadIcon.svg';
import ProductSpecification from '../../AmtcUser/AmtcProdInfoPg/ProductSpecification';
import ProductDescription from '../../AmtcUser/AmtcProdInfoPg/ProductDescription';
import { getSingleComProdServ } from '../../../services/com-service';
import ImageGallery from '../../AmtcUser/AmtcProdInfoPg/ImageGallery';
import { addCartServ } from '../../../services/prodreq-service';
import { useState } from 'react';
import MessagePopUp from '../../../components/MessagePopUp';
import constants from '../../../utils/Constants';


function ComProdInfoPg() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { setLoadingScreen, ctxtUser, setNavComValue } = useAuthContext();
    const [searchParams] = useSearchParams();
    const qProdId = searchParams.get("prodId");
    const comId = ctxtUser?.comId
    const location = useLocation()
    const userType = ctxtUser?.userType;
    const { isLoading, isError, error, data: prodData } = useQuery([QueryKey.amtcProdInfo, qProdId, comId], () => getSingleComProdServ(qProdId),
        {
            enabled: isNotEmpty(qProdId),
            refetchOnMount: true,
            refetchOnWindowFocus: false,
        })
    const typoHeadStyle = { borderColor: "rgb(0,0,0,0.1)", fontSize: 12, padding: 0.5, color: "rgb(0,0,0,0.6)", display: "inline-block", width: 140 }
    const typostyle = { borderColor: "rgb(0,0,0,0.1)", fontSize: 12, padding: 0.5, display: "inline-block" };
    const [addCartOpen, setAddCartOpen] = useState(false);
    const addCartPopupMsg = {
        title: "Product Added Into Cart Successfully",
        description: "",
        buttonText: "Continue"
    };

    const pathBtnsArr = [{
        label: "Category",
        handleClick: () => navigate(`${route.comCataLog}`)
    }, {
        label: prodData?.parCatName,
        handleClick: () => navigate(`${route.cSubCatList}/?catId=${prodData?.parCategoryId}&catName=${prodData?.parCatName}`)
    }, {
        label: prodData?.subCatName,
        handleClick: () => navigate(`${route.cProdsList}/?subCatId=${prodData?.subCategoryId1}`)
    }, {
        label: prodData?.prodName,
        handleClick: () => { }
    }]

    useEffect(() => {
        setLoadingScreen(isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    useEffect(() => {
        if (!qProdId) {
            navigate("/", { replace: true });
        }
    }, [qProdId, navigate]);


    useEffect(() => {
        setNavComValue({ comId })
        return () => setNavComValue({ comId: "" }); // Reset when leaving the page
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, comId]);

    function handleAddCartOpen() {
        setAddCartOpen(true)
    }

    function handleAddCartClose() {
        setAddCartOpen(false)
    }


    function handleDownloadClick(url) {
        if (ctxtUser?.isComUser) {
            notify("info", "Contact Admin for this file!")
        } else {
            window.open(url, "_blank", "noopener,noreferrer");
        }
    }

    async function handleAddCart() {
        setLoadingScreen(true);
        try {
            const payload = { amtcProdIdStrg: qProdId, qty: 1 }
            const { message } = await addCartServ(payload);
            notify("success", message);
            queryClient.invalidateQueries();
            // navigate(`${route.aProduct} /? prodId = ${qProdId}`, { replace: true });
            handleAddCartOpen()
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    }


    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }

    return (<>
        {prodData ? <ScrollBox height={"100%"} width={"100%"}>
            <Stack direction={"row"} spacing={2} alignItems={"center"} justifyContent={"space-between"} mb={2} pr={2}>
                <Stack direction={"row"} alignItems={"center"}>
                    <BackButton />
                    <PathBtns btnsArr={pathBtnsArr} />
                </Stack>
                <Stack direction={"row"} justifyContent="end" alignItems={"center"}  >
                    {(prodData?.isExpired === 1) && <Stack sx={{
                        borderRadius: 1, backgroundColor: "rgba(247, 64, 64, 0.5)", fontSize: 13, width: 230,
                        color: "rgba(7, 42, 200, 1)", height: 30, ml: 2
                    }} alignItems={"center"} justifyContent={"center"}>
                        Product agreed period is over!
                    </Stack>}
                    {isEmpty(prodData?.comProdIdStrg) && <Stack sx={{
                        borderRadius: 1, backgroundColor: "rgba(255, 183, 3, 1)", fontSize: 13, width: 230,
                        color: "rgba(7, 42, 200, 1)", height: 30
                    }} alignItems={"center"} justifyContent={"center"}>
                        Not in Company Catalogue!
                    </Stack>}

                </Stack>

            </Stack>
            <Stack direction={"row"} sx={{ marginBottom: 1, width: "100%" }} spacing={5} >
                <Stack direction={"column"} width={"30%"} >
                    <ImageGallery prodImgs={prodData?.prodImgs} />
                </Stack>
                <Stack direction={"column"} width={"40%"} >
                    <Typography sx={{ fontSize: 15, fontWeight: 500, marginBottom: 1, mt: 1 }}>{prodData?.prodName}</Typography>
                    <LabelTxt typoname={"AMTC Product ID"} typodetail={prodData?.amtcProdIdStrg} overflow={90} namestyle={typoHeadStyle} detailstyle={typostyle} />
                    <LabelTxt typoname={"Material Code"} typodetail={prodData?.comProdIdStrg} overflow={90} namestyle={typoHeadStyle} detailstyle={typostyle} />
                    <Typography sx={{ fontSize: 15, fontWeight: 500, mt: 1.5 }}>About this Product</Typography>
                    <Typography sx={{ fontSize: 14, fontWeight: 500, marginBottom: 0.5, mt: 1 }}>Product Specification</Typography>
                    <ProductSpecification specs={prodData?.prodSpecsJs || []} />
                    <ProductDescription details={prodData?.prodDesc || ""} mt={1} />
                </Stack>
                <Stack width={"30%"} height={"100%"} pr={1} gap={1}>
                    <Box sx={{ border: 1, borderColor: "rgba(0,0,0,0.1)", borderRadius: 2, py: 1, px: 3, height: "50%" }}>
                        <Typography sx={{ fontSize: 14, fontWeight: 500, }}> Manufacturers</Typography>
                        <Stack direction={"row"} spacing={2} alignItems="center" sx={{ paddingY: 1 }}>
                            <img src={industryIcon} alt="industimg1" style={{ width: 25, }} />
                            <Tooltip title={prodData?.mfrName}>
                                <Typography sx={{ fontSize: 12, fontWeight: 400, color: "rgba(0,0,0,0.8)" }}> {makeTxtOverFLow(prodData?.mfrName, 38)}</Typography>
                            </Tooltip>
                        </Stack>
                        <Box border={0.3} borderColor="rgba(0,0,0,0.08)" width={"100%"} my={1} />
                        <Typography sx={{ fontSize: 14, fontWeight: 500 }}> Attachments</Typography>
                        <ScrollBox height={"60%"}>
                            {(prodData?.prodFiles || []).map((i) => <Stack key={i?.id} direction={"row"} alignItems="center" justifyContent={"space-between"}
                                width={"100%"} sx={{ border: "1px dashed rgba(0,0,0,0.1)", borderRadius: 3, mb: 0.4 }}>
                                <Typography sx={{ fontSize: 12, pl: 1, fontWeight: 400, color: "rgba(0,0,0,0.8)" }}>{makeTxtOverFLow(i?.fileName, 31)} </Typography>
                                <Button onClick={() => handleDownloadClick(i?.fileUrl)}>
                                    <img src={downlodicon} alt="downlodicon" style={{ width: 25 }} />
                                </Button>
                            </Stack>)}
                        </ScrollBox>
                    </Box>

                    {isNotEmpty(prodData?.comProdIdStrg) && <Stack>
                        <Stack border={1} borderColor="rgba(0,0,0,0.1)" borderRadius={2} width={"100%"} fontSize={15} py={1} px={3} gap={1}>
                            <Stack direction={"row"} alignItems="center" justifyContent={"space-between"} width={"100%"}>
                                <Typography sx={{ fontSize: 12, fontWeight: 400, color: "rgba(0,0,0,0.8)", }}>Agreed Period </Typography>
                                <Typography sx={{ fontSize: 12, fontWeight: 400, backgroundColor: "rgba(253, 240, 213, 1)", }}>&nbsp;{`${formatDateWithJs(prodData?.agreedFrom)} to ${formatDateWithJs(prodData?.agreedTo)}`}&nbsp;</Typography>
                            </Stack>
                            <Stack direction={"row"} alignItems="center" justifyContent={"space-between"} width={"100%"}>
                                <Typography sx={{ fontSize: 12, fontWeight: 400, color: "rgba(0,0,0,0.8)", }}>Agreed Quantity </Typography>
                                <Typography sx={{ fontSize: 12, fontWeight: 400, backgroundColor: "rgba(253, 240, 213, 1)", }}>&nbsp;{prodData?.agreedQty}&nbsp;</Typography>
                            </Stack>
                            {(userType !== constants.requestor && userType !== constants.approver) && <Stack gap={1}>
                                <Stack direction={"row"} alignItems="center" justifyContent={"space-between"} width={"100%"}>
                                    <Typography sx={{ fontSize: 12, fontWeight: 400, color: "rgba(0,0,0,0.8)", }}>Price Agreement Id</Typography>
                                    <Typography sx={{ fontSize: 12, fontWeight: 400, backgroundColor: "rgba(253, 240, 213, 1)", }}>&nbsp;{prodData?.priceAgreeId}&nbsp;</Typography>
                                </Stack>
                                <Stack direction={"row"} alignItems="center" justifyContent={"space-between"} width={"100%"}>
                                    <Typography sx={{ fontSize: 12, fontWeight: 400, color: "rgba(0,0,0,0.8)", }}>Agreed Price (OMR)</Typography>
                                    <Typography sx={{ fontSize: 12, fontWeight: 400, backgroundColor: "rgba(253, 240, 213, 1)", }}>&nbsp;{prodData?.AgreedPrice}&nbsp;</Typography>
                                </Stack>
                                <Stack direction={"row"} alignItems="center" justifyContent={"space-between"} width={"100%"}>
                                    <Typography sx={{ fontSize: 12, fontWeight: 400, color: "rgba(0,0,0,0.8)", }}>Tax (%)</Typography>
                                    <Typography sx={{ fontSize: 12, fontWeight: 400, backgroundColor: "rgba(253, 240, 213, 1)", }}>&nbsp;{prodData?.comProdTax}&nbsp;</Typography>
                                </Stack>
                            </Stack>}
                        </Stack>
                        {(userType === constants.requestor || userType === constants.approver) && <Stack width={"100%"} alignItems={"center"} mt={2}>
                            <Button variant="contained" onClick={handleAddCart} sx={{
                                borderRadius: 2, backgroundColor: "rgba(255, 183, 3, 1)", fontSize: 13, width: 230,
                                color: "rgba(7, 42, 200, 1)"
                            }} >
                                ADD CART
                            </Button>
                        </Stack>}
                    </Stack>}
                </Stack>
            </Stack>
            <MessagePopUp isOpen={addCartOpen} onClose={handleAddCartClose} message={addCartPopupMsg} />
        </ScrollBox> : <Typography component={'h1'}>Data Not Found</Typography>}
    </>

    )
}
export default ComProdInfoPg